import { apiSlice, createPaginatedListEndpoint, createBodyMutation } from './baseApi';

export const expenseCategoryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getExpenseCategories: builder.query({
      query: (companyId) => ({
        url: '/expense-category/get-all-expense-categories',
        method: 'POST',
        body: { company_id: companyId },
      }),
      transformResponse: (response) => {
        const categories = response?.expenseCategories || [];
        return categories.map((category) => ({
          name: category.name,
          value: category._id,
          ...category,
        }));
      },
      providesTags: ['ExpenseCategories'],
    }),
    getExpenseCategoriesList: builder.query(
      createPaginatedListEndpoint({
        url: '/expense-category/get-all-expense-categories',
        responseKey: 'expenseCategories',
        tag: 'ExpenseCategories',
      })
    ),
    addExpenseCategory: builder.mutation(
      createBodyMutation({ url: '/expense-category/add-new-expense-category', invalidatesTags: ['ExpenseCategories'] })
    ),
    editExpenseCategory: builder.mutation(
      createBodyMutation({ url: '/expense-category/edit-expense-category', invalidatesTags: ['ExpenseCategories'] })
    ),
    deleteExpenseCategory: builder.mutation(
      createBodyMutation({ url: '/expense-category/delete-expense-category', invalidatesTags: ['ExpenseCategories'] })
    ),
  }),
});
